import { render, staticRenderFns } from "./DetailGarniture.vue?vue&type=template&id=146969ba&"
import script from "./DetailGarniture.vue?vue&type=script&lang=js&"
export * from "./DetailGarniture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports